import type { Snackbar } from "./snackbar";

export class CopyLink extends HTMLElement {
  async connectedCallback() {
    /* Copy Link function */
    const getUrlButton = this.querySelector("button");
    const snackbar = await this.#getComponent();

    if (getUrlButton) {
      getUrlButton.addEventListener("click", function () {
        const currentUrl = window.location.href;
        const getIcon = getUrlButton.querySelector("i");

        navigator.clipboard.writeText(currentUrl);
        snackbar?.show("Link erfolgreich in die Zwischenablage kopiert.");

        /* ui animation */
        getUrlButton.classList.add("change-bg");

        setTimeout(function () {
          getUrlButton.classList.add("start-animation");
        }, 500);

        if (getIcon) {
          getIcon.classList.replace("icon-link", "icon-check-default");
        }

        setTimeout(function () {
          if (getIcon) {
            getIcon.classList.replace("icon-check-default", "icon-link");
            getUrlButton.classList.remove("change-bg", "start-animation");
          }
        }, 2000);
      });
    }
  }

  #getComponent(): Promise<Snackbar | null> {
    return window.customElements
      .whenDefined("ws-snackbar")
      .then(async () => document.querySelector("ws-snackbar"));
  }
}

customElements.get("ws-copylink") ??
  customElements.define("ws-copylink", CopyLink);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-copylink": CopyLink;
  }
}
